// extracted by mini-css-extract-plugin
export default {"container":"ElementsComponent_container__N4z4D","elementsContainer":"ElementsComponent_elementsContainer__JucQW","element":"ElementsComponent_element__o28q8"};